import { StockReceiveData } from "./receive-stock.dto";

export class ReceiveStockData {
    receivedStocks: StockReceiveData[];   
    constructor(receivedStocks: StockReceiveData[]){
        this.receivedStocks = receivedStocks;
    } 
}